import { useQuery } from 'react-query'
import { api, apiConfig } from 'services'

export function useRecordSummary () {
  return useQuery(['record-summary', apiConfig.currentApiInstitute], () => api.records.summary(), {
    refetchInterval: 3000
  })
}
